import * as Sentry from "@sentry/react";

// If taking advantage of automatic instrumentation (highly recommended)
import { BrowserTracing } from "@sentry/tracing";
// Or, if only manually tracing
// import * as _ from "@sentry/tracing"
// Note: You MUST import the package in some way for tracing to work

const env = process.env.REACT_APP_ENV;
const dsn = process.env.REACT_APP_SENTRY_DSN;

const sentry = {
    init() {
        // let env = process.env.REACT_APP_ENV;
        // let dsn = process.env.REACT_APP_SENTRY_DSN;
        if (env === 'local' || !dsn) {
            return;
        }

        Sentry.init({
            dsn: dsn,
            environment: env,

            // To set a uniform sample rate
            tracesSampleRate: 1,

            // Alternatively, to control sampling dynamically
            // tracesSampler: samplingContext => { ... }


            // This sets the sample rate to be 10%. You may want this to be 100% while
            // in development and sample at a lower rate in production
            replaysSessionSampleRate: 0.1,
            // If the entire session is not sampled, use the below sample rate to sample
            // sessions when an error occurs.
            replaysOnErrorSampleRate: 1.0,

            integrations: [new Sentry.Replay(), new BrowserTracing()],
        });

        Sentry.setTag('env', env);
    },

    capture(error = null) {
        if (env === 'local' || !dsn) {
            return;
        }
        Sentry.captureException(error);
    }

}

export default sentry;
